// @ts-nocheck
import ga from "@store/Framework/Common/GoogleAnalytics";
import { TrackQuoteAdvancedFiltersUsedParameters } from "@store/Framework/Common/GoogleAnalytics/trackers/quote/trackQuoteAdvancedFiltersUsed";
import { PartialSpecific } from "@toolkit/Framework/Types/Common";

const useTrackQuoteAdvancedFiltersUsed = (
    parameters: PartialSpecific<TrackQuoteAdvancedFiltersUsedParameters, "filter_name"> = {},
    options?: Toolkit.GoogleAnalytics.Options,
) => ga.util.getEventTrackerHook(ga.track.quoteAdvancedFiltersUsed, parameters, options);

export default useTrackQuoteAdvancedFiltersUsed;
